import { render, staticRenderFns } from "./ExpenseAttachmentList.vue?vue&type=template&id=edb5dea0"
import script from "./ExpenseAttachmentList.vue?vue&type=script&lang=js"
export * from "./ExpenseAttachmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports